// extracted by mini-css-extract-plugin
export default {"giftView":"GiftView_giftView__TzGE7","deliveryInfo":"GiftView_deliveryInfo__6zCAB","deliveryText":"GiftView_deliveryText__vr1c-"};